// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import App from './App';
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';
import { oidcConfig } from './keycloak';
import { AuthProvider } from './Context/AuthProvider';

ReactDOM.render(
  <React.StrictMode>
    <OidcAuthProvider {...oidcConfig}>
      <BrowserRouter>
        <ChakraProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ChakraProvider>
      </BrowserRouter>
    </OidcAuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
